import { useNavigate } from 'react-router-dom';

// React Router's browser history stores an incrementing `idx` in
// window.history.state for every entry pushed during this browsing session,
// and the browser preserves that state across a refresh (it belongs to the
// session-history entry, not the page's JS runtime) - so `idx > 0` reliably
// means "there really is a previous entry to go back to", whether the user
// got here via in-app navigation or a refresh. A fresh tab or a deep link
// (shared URL, search result) lands on idx 0, where navigate(-1) would just
// exit the app, so those cases use the caller's fallback route instead.
export function useSmartBack(fallbackHref) {
  const navigate = useNavigate();

  return () => {
    const canGoBack = typeof window !== 'undefined' && window.history.state?.idx > 0;
    if (canGoBack) {
      navigate(-1);
    } else {
      navigate(fallbackHref || '/');
    }
  };
}

export default useSmartBack;
